export enum ContactStatus {
  DRAFT = 'draft',
  ACTIVE = 'active',
}
